import {
  Cell,
  Flow,
  FormError,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
  useStyles,
} from 'bold-ui'
import { Box } from 'components/Box'
import { CheckboxField, getFieldError } from 'components/form'
import { useField } from 'react-final-form'

import { AnoSelectField } from '../../citopatologico/AnoSelectField'
import { MamografiaPerguntaField } from '../model-mamografia'
import { anamneseCirurgiaTableOptions } from './model-anamnese'

export function MamografiaAnamneseCirurgiaTable() {
  const { classes } = useStyles(createStyles)

  const { input: fezCirurgiaInput, meta: fezCirurgiaMeta } = useField<boolean>(
    MamografiaPerguntaField.fezCirurgiaMama,
    {
      subscription: { value: true, error: true, touched: true, submitError: true, dirtySinceLastSubmit: true },
    }
  )
  const fezCirurgiaMama = fezCirurgiaInput.value
  const cirurgiaError = getFieldError(fezCirurgiaMeta)

  return (
    <Cell size={12} data-testid='fezCirurgiaMama'>
      <Box style={classes.box}>
        <Flow direction='vertical' gap={0.5}>
          <CheckboxField name={MamografiaPerguntaField.fezCirurgiaMama} label='Fez cirurgia na mama' />
          {cirurgiaError && (
            <Flow direction='horizontal' gap={0.25} alignItems='center'>
              <FormError>{cirurgiaError}</FormError>
              <Icon icon='infoCircleFilled' size={1} fill='danger' />
            </Flow>
          )}
        </Flow>
      </Box>
      {fezCirurgiaMama && (
        <Table style={classes.table}>
          <TableHead>
            <TableRow>
              <TableHeader style={classes.header}>Opções de cirurgia</TableHeader>
              <TableHeader style={classes.header}>Mama direita</TableHeader>
              <TableHeader style={classes.header}>Mama esquerda</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {anamneseCirurgiaTableOptions.map(({ label, valueDireita, valueEsquerda }) => (
              <TableRow key={label}>
                <TableCell style={classes.cell}>
                  <Text>{label}</Text>
                </TableCell>
                <TableCell style={classes.cell} data-testid={valueDireita}>
                  <AnoSelectField placeholder='Ano da cirurgia' name={valueDireita} />
                </TableCell>
                <TableCell style={classes.cell} data-testid={valueEsquerda}>
                  <AnoSelectField placeholder='Ano da cirurgia' name={valueEsquerda} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Cell>
  )
}

const createStyles = () => ({
  box: {
    padding: '0.75rem',
  },
  table: {
    padding: '1rem',
    borderTop: 'none',
  },
  header: {
    width: '33.33%',
  },
  cell: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
})
